// removed by extract-text-webpack-plugin
module.exports = {"voucher":"_3q-m3T4KrErGyJ9Vz8ykoC","title":"_2urzKX8DpypJqSZMQq3Qsf","qr":"_2ohsBPEK8deVrfFIwlBBTr","token":"_1WkYYoUu-7Yi5z3L3onUNs","data":"_2Bu46UWC4biSEZvh94vz_f","boxList":"_1ng3tdoX2K5tySHjLoEwm"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/Voucher/style.css
// module id = 414
// module chunks = 37